import { ImpactType, UserImpactAggregates } from "@ecologi/shared";
import styled from "@emotion/styled";
import React from "react";
import useMedia from "react-use/lib/useMedia";
import { EmblaCarousel } from "../../EmblaCarousel";
import { ProjectCard } from "./ProjectCard";

const SupportedProjectsSlide = styled.div`
  align-items: stretch;
  display: flex;
  flex-wrap: nowrap;
`;

function toChunks<T>(items: T[], size: number) {
  return Array.from({ length: Math.ceil(items.length / size) }, (_, i) =>
    items.slice(i * size, i * size + size)
  );
}

export interface SupportedProjectsProps {
  userImpactAggregates: UserImpactAggregates;
}

export const SupportedProjects = ({
  userImpactAggregates,
}: SupportedProjectsProps) => {
  const isMobile = useMedia("(max-width: 480px)");
  const numberOfSlidesToShow = isMobile ? 1 : 2;
  const numberOfCardsToShow = 8 * numberOfSlidesToShow;

  // Limit to 8 cards (or 8 slides on desktop)
  const allSlides = (
    userImpactAggregates[ImpactType.CARBON_OFFSETS].data?.projects ?? []
  ).slice(0, numberOfCardsToShow);

  // Chunk these projects into arrays of 2 and map them into project on desktop
  const slides = toChunks(allSlides, numberOfSlidesToShow).map((chunk) => (
    <SupportedProjectsSlide key={chunk.map((project) => project.id).join("-")}>
      {chunk.map((project) => (
        <ProjectCard
          userImpactAggregates={userImpactAggregates}
          key={project.id}
          project={project}
        />
      ))}
    </SupportedProjectsSlide>
  ));

  // Dont wrap the slides in the carousel unless we actually need
  // to paginate. Without this you end up with disabled arrows for both directions
  if (slides.length <= numberOfSlidesToShow) {
    return <>{slides}</>;
  }

  return <EmblaCarousel.Multislide slides={slides} />;
};
